<template>
    <div class="content">
        <div>
            <Form :label-width="98">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="投保公司">
                            <Input v-model.trim="params.applicantInfo" clearable placeholder="请输入投保公司" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="批单编号">
                            <Input v-model.trim="params.endorseNo" clearable placeholder="请输入批单编号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="关联保单号">
                            <Input v-model.trim="params.cntrNo" clearable placeholder="请输入关联保单号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="批单状态">
                            <Select v-model="params.endorseStatus" clearable>
                                <Option v-for="(item,index) in list" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="16" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div>
            <i-table :columns="columns" url="/broker/insurance/endorse/list.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="action">
                    <a @click="toDetail(row)">查看详情</a>
                </template>
            </i-table>
        </div>
    </div>
</template>
<script>
    import ITable from '@/components/common/ITable'
    export default {
        components:{ ITable },
        data () {
            return {
                loading: false,
                params: {
                    bizId: 'TRUCK_EMPLOYERS_LIABILITY_INSURANCE'
                },
                columns: [
                    {title:'批单编号',key:'endorseNo',width: 270,fixed: 'left'},
                    {title:'关联保单号',key:'cntrNo',width: 260},
                    {title:'批单创建时间',key:'createTime',width: 180},
                    {title:'投保公司名称',key:'applicantName',width: 180,ellipsis: true,tooltip: true},
                    {title:'产品名称',key:'productName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保险公司',key:'insuranceCompanyName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'批单状态',key:'endorseStatusDesc',width: 120},
                    {title:'批单保费（元）',key:'premium',width: 140,align: 'right'},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 100,
                        align: 'center',
                        fixed: 'right'
                    }
                ],
                list:[
                    {
                        value: 'UNCONFIRMED',
                        label: '待确认'
                    },
                    {
                        value: 'CONFIRMED',
                        label: '已确认'
                    },
                    {
                        value: 'REVIEWING',
                        label: '核保中'
                    },
                    {
                        value: 'REVIEWED_REJECTED',
                        label: '核保失败'
                    },
                    {
                        value: 'ENDORSE_ISSUING',
                        label: '批改出单中'
                    },
                    {
                        value: 'FINISHED',
                        label: '已完成'
                    },
                    {
                        value: 'REJECTED',
                        label: '已拒保'
                    }
                ]
            }
        },
        created () {
        },
        methods:{
            tabChange(){
                this.$refs.table.getList()
            },
            toDetail(row){
                window.location.href=`/haierProduct.html#/my/rider-detail/${row.endorseNo}/rider`
            }
        }
    }
</script>
<style lang="less" scoped>
    .content{
        background: #fff;
        padding: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/rider/index.vue